<section class="bk-panel gt" aria-labelledby="gt-title">
  <header class="gt__head">
    <h2 class="bk-eyebrow" id="gt-title">Recipient groups</h2>
    @if (rows.length) {
      <span class="gt__note">Recipients by gender and age in each group</span>
    }
  </header>

  <data-table label="Campaign recipients" [seamless]="true" [loading]="loading" [maxHeight]="'560px'" [skeletonColumns]="6" [skeletonRows]="4">
    @if (rows.length) {
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col">Group</th>
            <th scope="col" class="col-type">Type</th>
            <th scope="col" class="num">Recipients</th>
            <th scope="col" class="num col-gender">Male</th>
            <th scope="col" class="num col-gender">Female</th>
            <th scope="col" class="num col-gender">Other</th>
            <th scope="col" class="num col-age">16–35</th>
            <th scope="col" class="num col-age">36–65</th>
            <th scope="col" class="num col-age">66+</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.key) {
            <tr>
              <td class="col-name">
                <span class="gt__name">{{ row.name }}</span>
                <span class="gt__type-inline">{{ row.type }}</span>
              </td>
              <td class="quiet col-type">{{ row.type }}</td>
              <td class="num gt__strong">{{ row.recipients }}</td>
              <td class="num quiet col-gender">{{ row.male }}</td>
              <td class="num quiet col-gender">{{ row.female }}</td>
              <td class="num quiet col-gender">{{ row.other }}</td>
              <td class="num quiet col-age">{{ row.young }}</td>
              <td class="num quiet col-age">{{ row.middle }}</td>
              <td class="num quiet col-age">{{ row.older }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <app-empty-state
        icon="groups"
        message="No recipient breakdown yet"
        hint="Group figures appear once the campaign's audience has been counted."
        size="medium"
      />
    }
  </data-table>
</section>
